import { createAction } from '@ngrx/store';

export namespace AnalyticsActions {
  export const Types = {
    ACTION: '[Analytics] action',
    ACTIVITY_LIBRARY_GDRIVE: '[Analytics] Activity Library Drive Opened',
  };

  export const AnalyticsAction = createAction(Types.ACTION);
  export const ActivityLibraryDriveOpen = createAction(Types.ACTIVITY_LIBRARY_GDRIVE);
}
